module.exports = __webpack_public_path__ + "font_darts_daughter.7ebc9a9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/font_darts_daughter.png
// module id = mEzk
// module chunks = 0